'use client';

import { type ReactNode, useState, useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from 'mode-shared/configs/query';

export function Providers({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  return <QueryClientProvider client={queryClient}>{mounted && children}</QueryClientProvider>;
}
